import useWindowDimensions from './useWindowDimensions'

const useIsResponsive = (): boolean => {
  const { width, height } = useWindowDimensions()
  const isResponsive: boolean = width < 1024 && height < 1280
  return isResponsive
}

export default useIsResponsive
